import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `StackedHeadersDirective` represent a stacked header of the react Kanban board.
 * It must be contained in a Kanban component(`KanbanComponent`).
 * ```tsx
 * <KanbanComponent>
 *  <StackedHeadersDirective>
 *   <StackedHeaderDirective keyField='Open' text='To Do'></StackedHeaderDirective>
 *   <StackedHeaderDirective keyField='Close' text='Completed'></StackedHeaderDirective>
 *  <StackedHeadersDirective>
 * </KanbanComponent>
 * ```
 */
export class StackedHeaderDirective extends ComplexBase {
}
StackedHeaderDirective.moduleName = 'stackedHeader';
export class StackedHeadersDirective extends ComplexBase {
}
StackedHeadersDirective.propertyName = 'stackedHeaders';
StackedHeadersDirective.moduleName = 'stackedHeaders';
